import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowRight, Play } from 'lucide-react';

export const AboutCTA = () => {
  return (
    <section className="relative bg-midnight-green overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.unsplash.com/photo-1556910103-1c02745aae4d?q=80&w=2070&auto=format&fit=crop"
          alt="Camp staff serving meals outdoors"
          className="w-full h-full object-cover opacity-30"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-midnight-green/95 via-deep-teal/90 to-copper/85" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-24 md:py-32">
        <div className="text-center">
          <h2 className="font-playfair text-4xl md:text-5xl lg:text-6xl font-bold text-ivory mb-6">
            Join the Camps Revolutionizing Their Kitchens
          </h2>
          <p className="font-inter text-xl md:text-2xl text-ivory/90 mb-12 max-w-3xl mx-auto leading-relaxed">
            Start your next season with a system that saves time, reduces waste, and gives your team confidence.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button
              asChild
              size="lg"
              className="bg-copper hover:bg-copper/90 text-ivory font-semibold shadow-lg text-lg px-8 py-6 group"
            >
              <Link to="/contact" className="flex items-center gap-2">
                Request a Camp Demo
                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </Link>
            </Button>
            <Button
              asChild
              size="lg"
              variant="outline"
              className="bg-ivory/10 border-ivory text-ivory hover:bg-ivory hover:text-midnight-green font-semibold text-lg px-8 py-6 backdrop-blur-sm group"
            >
              <Link to="/#features" className="flex items-center gap-2">
                <Play className="w-5 h-5" />
                See How It Works
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};
